// src/slices/ads/thunk.js
import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const API_URL = process.env.REACT_APP_API_URL;

// GET ADS
export const getAds = createAsyncThunk("ads/getAll", async (_, { rejectWithValue }) => {
  try {
    const token = localStorage.getItem("token");

    const { data } = await axios.get(`${API_URL}/ads`, { headers: { token } });
    return data;
  } catch (error) {
    return rejectWithValue(error.response?.data || "Something went wrong");
  }
});
